// extracted by mini-css-extract-plugin
export default {"logo":"eA8ZjFH"};